<template>
  <div v-bind:style='{left:obj.view.left + "px", top:obj.view.top + "px", width:obj.view.w + "px", height:obj.view.h + "px"}' class='flowchart-object jsplumb-draggable jsplumb-droppable' :id="obj.view.id">
    <div class="redirect_shell">
      <div class="title control">
        <div class="redirectTitle">{{$t('scenarios.konstruktor.canvas.add.redirectToOperator')}}</div>
        <button class="delete" aria-label="delete" v-on:click="deleteNode()"></button>
      </div>
      <div class="control" style="margin-top: 6px">
        <input v-model="obj.redirect" :placeholder="$t('scenarios.konstruktor.canvas.answer.sipSubUrl')" :title="$t('scenarios.konstruktor.canvas.answer.sipDubUrl')" class="input sipNumber"/>
      </div>
    </div>
  </div>
</template>

<script>

    import { BaseNodeComponent } from './jsplumb-extends/jsplumb-vue'
    // import i18n from '../../../translations/i18n'

    export default {
      name: 'Redirect',
      mixins:[ BaseNodeComponent ]
      // i18n: i18n
    }
</script>

<style scoped>
  .redirect_shell {
    border-radius: 10px;
    vertical-align: top;
    background-color: ghostwhite;
    padding: 10px;
  }
  .title .delete {
    float: right;
    background-color: indianred;
    cursor: pointer;
  }
  .title {
    font-size: 16px;
    white-space: nowrap;
    text-align: left;
    height: 32px;
    margin-bottom: 0;
    display: inline;
  }

  .redirect_shell .title .redirectTitle {
    padding-right: 16px;
    font-size: 16px;
  }

  .redirect_shell .title div {
    display: inline;
  }
</style>



// WEBPACK FOOTER //
// Redirect.vue?8461d46c